export function timestamp() {
  return window.performance?.now?.() ?? new Date().getTime();
}
